import { render, staticRenderFns } from "./previewImg.vue?vue&type=template&id=b1f7227c&scoped=true"
import script from "./previewImg.vue?vue&type=script&lang=js"
export * from "./previewImg.vue?vue&type=script&lang=js"
import style0 from "./previewImg.vue?vue&type=style&index=0&id=b1f7227c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f7227c",
  null
  
)

export default component.exports